import dayjs from 'dayjs'
import { useEffect } from 'react'

import { useEndActiveSessionMutation } from 'src/app/appApiQueries'
import { selectSession } from 'src/app/session'
import { useAppSelector } from './useRTK'
import { zoomSdkApi } from 'src/app/zoomSdkQueries'

// This hook will auto end a session if the meetingIds don't match or they do match and the days are different
export function useAutoEndSession() {
  const { data: meetingId } =
    zoomSdkApi.endpoints.getMeetingContext.useQueryState('getMeetingContext', {
      selectFromResult: (result) => ({ data: result?.data?.meetingID }),
    })

  const session = useAppSelector(selectSession)

  const [endActiveSession, { isLoading }] = useEndActiveSessionMutation()

  useEffect(() => {
    const currentDay = dayjs(Date.now())
    const convertedDateCreated = dayjs(session.dateCreated)
    // is the day different and at least 4 hours since the creation of the active session
    const isDifferentDay =
      !currentDay.isSame(convertedDateCreated, 'day') &&
      Math.abs(currentDay.diff(convertedDateCreated, 'hour')) > 4
    if (
      (session.id && meetingId && meetingId !== session.meetingId) ||
      (session.id && meetingId === session.meetingId && isDifferentDay)
    ) {
      endActiveSession()
    }
  }, [
    endActiveSession,
    meetingId,
    session.dateCreated,
    session.meetingId,
    session.id,
  ])

  return isLoading
}
